// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"131":"65323ae7f4d33bd6","706":"ab1d909b6854d75b","859":"2010d9fe5f01a4f2"}[chunkId] + ".js";
};